module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_7.3a90bd52.jpg";